'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  margin: 0;\n  padding: ', 'px;\n\n  display: flex;\n  flex-flow: row wrap;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n\n  list-style: none;\n'], ['\n  height: ', ';\n  margin: 0;\n  padding: ', 'px;\n\n  display: flex;\n  flex-flow: row wrap;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n\n  list-style: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: ', 'px;\n  height: ', 'px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: ', ';\n  background: ', ';\n  border-radius: 3px;\n  font-size: ', 'px;\n  cursor: pointer;\n  transition: background 200ms ease;\n\n  &:hover,\n  &:focus {\n    background: ', ';\n    color: ', ';\n  }\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: ', ';\n  background: ', ';\n  border-radius: 3px;\n  font-size: ', 'px;\n  cursor: pointer;\n  transition: background 200ms ease;\n\n  &:hover,\n  &:focus {\n    background: ', ';\n    color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons = require('../../models/icons');

var _icons2 = _interopRequireDefault(_icons);

var _variables = require('../../styles/variables');

var _variables2 = _interopRequireDefault(_variables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledList = _styledComponents2.default.ul(_templateObject, function (_ref) {
  var height = _ref.height;
  return height ? height + 'px' : 'auto';
}, _variables2.default.PADDING);

var Icon = _styledComponents2.default.li(_templateObject2, function (props) {
  return props.iconSize;
}, function (props) {
  return props.iconSize;
}, _variables2.default.BLACK, _variables2.default.WHITE, function (props) {
  return props.iconSize / 2;
}, _variables2.default.LIGHT_GREY, _variables2.default.PRIMARY);

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.iconSize !== nextProps.iconSize) {
        // iconSize has changed, re-render
        return true;
      }

      if (this.props.icons.length !== nextProps.icons.length) {
        // icons.length has changed, re-render
        return true;
      }

      // icons.length is the same, time to do a deep compare
      var names = this.props.icons.map(function (x) {
        return x.name;
      });
      var nextnames = nextProps.icons.map(function (x) {
        return x.name;
      });

      // Naive array comparison
      if (JSON.stringify(names) !== JSON.stringify(nextnames)) {
        return true;
      }

      // Don't re-render unless one of the above conditionals is true
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          onIconClick = _props.onIconClick,
          iconSize = _props.iconSize,
          icons = _props.icons;


      return _react2.default.createElement(
        StyledList,
        {
          iconSize: iconSize,
          height: height
        },
        icons.map(function (icon) {
          return (// eslint-disable-line no-unused-vars
            _react2.default.createElement(
              Icon,
              {
                key: icon.name,
                title: icon.name,
                onClick: function onClick() {
                  onIconClick(icon);
                },
                iconSize: iconSize
              },
              icon.render()
            )
          );
        })
      );
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  height: _propTypes2.default.number,
  onIconClick: _propTypes2.default.func,
  iconSize: _propTypes2.default.number,
  icons: _icons2.default
};
_class.defaultProps = {
  height: 0,
  onIconClick: function onIconClick() {},
  icons: [],
  iconSize: 40
};
exports.default = _class;